import { createApiHooks, schemaToQueryParameters } from '@apis/next/common';
import {
  PaymentSlipBatch,
  PaymentSlipBatchPost,
  PaymentSlipBatchPatch,
  PaymentSlipBatchPages,
  PaymentSlipBatchSearchQuery,
  PaymentSlipBatchResponse,
} from '@models/next/PaymentSlipBatch';
import { z } from 'zod';

export const dashboardPaymentSlipBatchApis = createApiHooks('/dashboard/payment-slip-batch', [
  {
    method: 'get',
    path: '/',
    parameters: schemaToQueryParameters(PaymentSlipBatchSearchQuery),
    response: PaymentSlipBatchPages,
  },
  {
    method: 'get',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
    ],
    response: PaymentSlipBatch,
  },
  {
    method: 'post',
    path: '/',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PaymentSlipBatchPost,
      },
    ],
    response: PaymentSlipBatchResponse,
  },
  {
    method: 'patch',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
      {
        type: 'Body',
        name: 'body',
        schema: PaymentSlipBatchPatch,
      },
    ],
    response: z.any(),
  },
  {
    method: 'delete',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
      {
        type: 'Body',
        name: 'body',
        schema: z.any(),
      },
    ],
    response: z.any(),
  },
]);
